import { Link } from 'react-router-dom'

import { ArrowBack } from '../../../../components/SvgIcon'

// The bar pinned to the bottom of each step: back on the left, the main button on the right
const Footer = ({
  backTo = '',
  onSubmit = () => {},
  children = null,
  note = null,
  buttonText = '',
  buttonClass = '',
  replace = false,
  errorShow = false,
  errorMessage = '',
  submitButtonRef = null,
  disabled = false,
}) => (
  <div className="cbActionBar">
    <div className="cbActionBarInner">
      <div className="cbActionBarLeft">
        {backTo !== null ? (
          <Link replace={replace} className="cbBack" to={backTo}>
            <ArrowBack />
            Back
          </Link>
        ) : null}
        {children}
      </div>
      <div className="cbActionBarRight">
        {errorShow && errorMessage ? (
          <span className="cbActionError" role="alert">
            {errorMessage}
          </span>
        ) : (
          note
        )}
        <button
          onClick={onSubmit}
          ref={submitButtonRef}
          disabled={disabled}
          className={`cbNextButton ${buttonClass}`}
        >
          {buttonText}
          <span aria-hidden="true">→</span>
        </button>
      </div>
    </div>
  </div>
)

export default Footer
